import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Uuid } from '@ftr/contracts/type/shared'
import { CourtSystemForbiddenType } from '@ftr/data-court-system'
import { CourtSystemParams } from '@ftr/routing-paths'
import { CourtSystemForbiddenComponent } from '@ftr/ui-court-system'

@Component({
  selector: 'ftr-court-system-forbidden-page',
  template:
    '<ftr-court-system-forbidden [courtSystemId]="courtSystemId" [courtSystemForbiddenType]="courtSystemForbiddenType" />',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CourtSystemForbiddenComponent],
})
export class CourtSystemForbiddenPage {
  courtSystemId: Uuid
  courtSystemForbiddenType: CourtSystemForbiddenType

  constructor(route: ActivatedRoute) {
    const forbiddenType = route.snapshot.queryParamMap.get(CourtSystemParams.Forbidden)
    this.courtSystemForbiddenType = forbiddenType
      ? (forbiddenType as CourtSystemForbiddenType)
      : CourtSystemForbiddenType.UseConditionsNotAccepted
    this.courtSystemId = route.snapshot.queryParamMap.get(CourtSystemParams.CourtSystemId)!
  }
}
